export default "__VITE_ASSET__deupi1yH__"